import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "utils/piwikUtils";

export function PiwikRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    const url = location.pathname + location.search + location.hash;
    trackPageView(url);
  }, [location]);

  return null;
}
